module.exports = __webpack_public_path__ + "img/symbol_4.0667d5d2.png";